import { createAction } from '../../helpers/redux-actions.helper'
import { ActionsUnion } from '../../helpers/types.helper'

export const INCREASE_COUNTER = 'INCREASE_COUNTER'
export const TEST_API = 'TEST_API'
export const TEST_API_WATCHER = 'TEST_API_WATCHER'

export const Actions = {
  increaseCounter: () => createAction(INCREASE_COUNTER),
  testApi: (params: any) => createAction(TEST_API, params),
}

export type Actions = ActionsUnion<typeof Actions>
